import {
  Organization,
  Teacher,
  Course,
  Character,
  Video,
  Font,
  Stars,
  Orders,
  Commodities,
  Vip,
  Stages
} from '@/api'

export default {
  'organizations': {
    Api: Organization,
    dataKey: 'organizations',
    emptyText: '空空如也'
  },
  'teachers': {
    Api: Teacher,
    dataKey: 'teachers',
    emptyText: '机构暂时没有老师上线哟'
  },
  'courses': {
    Api: Course,
    dataKey: 'courses',
    emptyText: '老师暂时没有上传课程哟'
  },
  'course-unlocked': {
    Api: Course,
    dataKey: 'courses',
    emptyText: '你还未拥有解锁课程哟'
  },
  'characters': {
    Api: Character,
    dataKey: 'characters',
    emptyText: '老师暂时没有上传视频哟'
  },
  'videos': {
    Api: Video,
    dataKey: 'videos',
    emptyText: '老师暂时没有上传内容哟'
  },
  'stages': {
    Api: Stages,
    dataKey: 'stages',
    emptyText: '老师暂时没有上传课程目录'
  },
  'fonts': {
    Api: Font,
    dataKey: 'fonts',
    emptyText: '老师暂时没有上传字帖哟'
  },
  'stars-characters': {
    Api: Stars,
    dataKey: 'characters',
    emptyText: '空空如也'
  },
  'stars-videos': {
    Api: Stars,
    dataKey: 'videos',
    emptyText: '空空如也'
  },
  'orders': {
    Api: Orders,
    dataKey: 'orders',
    emptyText: '空空如也'
  },
  'commodities': {
    Api: Commodities,
    dataKey: 'commodities',
    emptyText: '空空如也'
  },
  'related-courses': {
    Api: Vip,
    dataKey: 'courses',
    emptyText: '空空如也'
  },
  'related-videos': {
    Api: Vip,
    dataKey: 'videos',
    emptyText: '空空如也'
  },
  'related-fonts': {
    Api: Vip,
    dataKey: 'fonts',
    emptyText: '空空如也'
  }
}
